import Vue from 'vue'
import Vuetify from 'vuetify'
import VueCookie from 'vue-cookie'
import 'vuetify/dist/vuetify.css'
import App from './App'
import router from './router'
import { store } from './store'

import Alert from './components/shared/Alert'

const brand = {
  name: 'ice',
  displayName: 'Ice Wireless',
  logo: {
    // svgPath: 'logo.svg',
    pngPath: 'logo.png'
  },
  dir: 'ice',
  rules: {
    pin: (value) => {
      if (value != null && value.length >= 4 && value.length <= 10) {
        return true
      } else {
        return 'Please enter a valid PIN'
      }
    },
    email: (value) => {
      return /^\w+([.+-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || 'Please enter a valid e-mail'
    }
  }
}

Vue.use(Vuetify, { theme: {
  primary: '#105079',
  accent: '#1E93B5',
  'accent-light': '#E9F2F6',
  secondary: '#424242',
  secondaryAccent: '#B7B7B7',
  secondaryAlt: '#E1E1E1',
  error: '#FF5252',
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#FFC107'
}})

Vue.use(VueCookie)

Vue.config.productionTip = false
Vue.config.errorHandler = (err, vm, info) => {
  // handle error
  // `info` is a Vue-specific error info, e.g. which lifecycle hook
  // the error was found in. Only available in 2.2.0+
  console.log('[CATCH ALL ERROR HANDLER]')
  // console.error(err)
  // console.info(vm)
  // console.info(info)
}

Vue.mixin({
  computed: {
    brand () {
      return brand
    }
  },
  methods: {
    getImgUrl (img) {
      return require('./assets/' + img)
    },
    getLogo (brand) {
      if (brand.logo.svgPath != null) {
        return require(`./brands/${brand.dir}/${brand.logo.svgPath}`)
      } else {
        return require(`./brands/${brand.dir}/${brand.logo.pngPath}`)
      }
    },
    getBrandPath (brand, img) {
      return `./brands/${brand.dir}/${img}`
    },
    getBrandUrl (brand, img) {
      // return require('./brands/' + img)
      return require(`./brands/${brand.dir}/${img}`)
    }
  }
})

/**
* Formats currency
* Example: 53.50 => $53.50
*
* @param {String} phone
* @return {Void}
*/
Vue.filter('currency', (value) => {
  if (!value) return

  return '$' + value.toFixed(2)
})

/**
 * Formats a phone number.
 * Example: 123-456-7890 => (123) 456-7890
 *
 * @param {String} phone
 * @return {Void}
 */
Vue.filter('phone', (phone) => {
  if (!phone) return

  return phone.replace(/[^0-9]/g, '')
              .replace(/^(\+?1)?(\d{3})(\d{3})(\d{4})/, '$1 ($2) $3-$4')
})

Vue.filter('friendlyDisplayPhone', (phone) => {
  return phone.replace(/[^0-9]/g, '')
              .replace(/^(\+?1)?(\d{3})(\d{3})(\d{4})/, '$1 ($2) $3-$4')
})

Vue.component('app-alert', Alert)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  brand,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js